const StoredEntity = require('./stored-entity');

class RequestFormField extends StoredEntity {

	constructor() {
		super();
		this.type = '';
		this.internalName = '';
		this.labels = []; //lang, label
		this.descriptions = []; //lang, label
		this.mandatory = false;
		this.options = []; //id, labels, descriptions, key
		this.tags = [];
		// this.globalHintIfFilledOut = [];//labels
	}

	getType() {
		return this.type;
	}

	getMandatory() {
		return this.mandatory;
	}

	getTags() {
		return this.tags;
	}

	getOptions() {
		return this.options;
	}

	validateInput(input) {
		if (typeof input === 'undefined' || input === null) {
			if (this.mandatory) throw new Error('mandatory field missing');
			else return;
		}
		switch (this.type) {
			case 'select':
				if (!this.options.map(o => o.id).includes(input)) throw new Error('invalid value on field');
				break;

			case 'multiselect':
				if (!Array.isArray(input)) throw new Error('must be an array');
				if (input.length === 0 && this.mandatory) throw new Error('input is mandatory');
				input.forEach(c => {
					if (!this.options.map(o => o.id).includes(c)) throw new Error('invalid value on field');
				});
				break;

			default:
			case 'textfield':
			case 'singleline-textfield':
				if (typeof input !== 'string') throw new Error('input must be string');
				if (input.trim().length === 0 && this.mandatory) throw new Error('input is mandatory');
				break;

			case 'numberfield':
				if (typeof input !== 'number') throw new Error('input must be a number');
				if (input < 0) throw new Error('input can not be negative');
				break;

			case 'datefield':
				if (new Date(input).toString() === 'Invalid Date') throw new Error('invalid date input');
				break;

		}
	}

}

RequestFormField.TYPES = [
	'select',
	'multiselect',
	'singleline-textfield',
	'textfield',
	'datefield',
	'numberfield',
	'hidden'
];

RequestFormField.ANIMALS_REQUIRED = 'animals_required';
RequestFormField.ANIMALS_AVAILABLE = 'animals_available';
RequestFormField.MAIN_ANSWER = 'main_answer';
RequestFormField.AGR_REASON = 'agr_reason';
RequestFormField.SPECIES_NAME = 'species_name';
RequestFormField.MAKE_ATTACH_REQUIRED = 'attachments_required';

RequestFormField.TAGS = [
	'viehverkehrv_number', 	//text field for export
	'exception_1344',		//select for export
	'animal_ident_method',	//select for export
	'detailed_description',	//text for export
	'current_animal_count',	//number for export
	'animal_noneco_count_12mo', //text for export
	'reason_dehorning',
	'ear_tag_number',
	'access_date',
	'birth_date',
	'sperm_separation',
	'embryo_transfer',
	'company_contact',
	RequestFormField.MAIN_ANSWER,		//accepted, rejected
	RequestFormField.AGR_REASON,		//needed for statistics, select for agr
	'reason_text_agr',		//text field for export
	'reason_text_ins',		//text field for export
	'reason_text_aso',		//text field for export
	'reason_text_aut',		//text field for export
	RequestFormField.MAKE_ATTACH_REQUIRED,
	RequestFormField.SPECIES_NAME,
	RequestFormField.ANIMALS_REQUIRED,	//amount required
	RequestFormField.ANIMALS_AVAILABLE //amount response sup
];

module.exports = RequestFormField;
